import React from 'react';
import * as Game from '../../../models/game';
import { round2, ratioToPercent } from '../../../lib/format';

export const SummaryTable = ({ lineup }) => (
  <div className="s-lineup-explorer__table-container">
    <div className="score-table">
      <FourFactorsTable lineup={lineup} />
      {SummaryGroups.map(group => (
        <GroupTable key={group.title} lineup={lineup} {...group} />
      ))}
    </div>
  </div>
);

const GroupTable = ({ title, data, lineup }) => (
  <table>
    <thead>
      <tr>
        <th colSpan="2" className="score-table__categories-title">
          {title}
        </th>
      </tr>
    </thead>
    <tbody className="score-table__categories-values">
      {data.map(item => (
        <tr key={item.name}>
          <th>{item.name}</th>
          <td>{lineup && round2(item.getValue(lineup))}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

const FourFactorsTable = ({ lineup }) => (
  <table>
    <thead>
      <tr>
        <th colSpan="2" className="score-table__categories-title">
          Four Factors
        </th>
      </tr>
    </thead>
    <tbody className="score-table__categories-values">
      {FourFactorsGroup.data.map(item => (
        <tr key={item.name}>
          <th>{item.name}</th>
          <td>{lineup && ratioToPercent(item.getValue(lineup))}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

const FourFactorsGroup = {
  data: [
    {
      name: 'Net EFG',
      getValue: Game.getNetEFG,
    },
    {
      name: 'Net FTR',
      getValue: Game.getNetFTR,
    },

    {
      name: 'Net TOV',
      getValue: Game.getNetTOV,
    },
    {
      name: 'Net ORR',
      getValue: Game.getNetORR,
    },
  ],
};
const SummaryGroups = [
  {
    title: 'Totals',
    data: [
      { name: 'Team Points Scored', getValue: Game.getTeamPointsScored },
      {
        name: 'Opponents Points Scored',
        getValue: Game.getOpponentsPointsScored,
      },
      { name: 'Plus-Minus', getValue: Game.getTotalPlusMinusPoints },
      { name: 'Shifts', getValue: Game.getTotalShifts },
    ],
  },
  {
    title: 'Possessions',
    data: [
      { name: 'Total', getValue: Game.getTotalPossessions },
      { name: 'Points per 100', getValue: Game.getPointsPer100Possessions },
      {
        name: 'Allowed points per 100',
        getValue: Game.getPointsAllowedPer100Possessions,
      },
      { name: 'Net per 100', getValue: Game.getNetPer100Possessions },
    ],
  },
  {
    title: 'Minutes',
    data: [
      { name: 'Total', getValue: Game.getTotalMinutes },
      { name: 'Points per 36', getValue: Game.getPointsPer36Minutes },
      {
        name: 'Allowed points per 36',
        getValue: Game.getPointsAllowedPer36Minutes,
      },
      { name: 'Net per 36', getValue: Game.getNetPer36Minutes },
    ],
  },
];
